import React from "react";
import { findArray } from 'helpers/utils'
import { useViewport } from 'components/general/useViewPort'
import Competitor from "components/presentation/Competitor";
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const CurrentCompetitor = ({ data }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();

    let street = false
    let park = false
    let final

    if (data?.results?.eventUnitCode.includes('STREET')) {
        street = true
    }
    else if (data?.results?.eventUnitCode.includes('PARK')) {
        park = true
    }

    if (data?.results?.eventUnitCode.includes('QUAL')) {
        final = false
    }
    else if (data?.results?.eventUnitCode.includes('FNL')) {
        final = true
    }

    let currentCompetitorConfig = data?.config?.extendedConfig
    let currentCompetitor = data?.results?.currentCompetitorResult

    let run1 = currentCompetitor?.extendedResults?.find(er => er?.er_pos === '1') ? currentCompetitor?.extendedResults?.find(er => er?.er_pos === '1') : ''

    let run2 = currentCompetitor?.extendedResults?.find(er => er?.er_pos === '2') ? currentCompetitor?.extendedResults?.find(er => er?.er_pos === '2') : ''

    let trick1, trick2, trick3, trick4, trick5 = ''
    let run3 = ''

    if (street) {
        trick1 = currentCompetitor?.extendedResults?.find(er => er?.er_pos === '3') ? currentCompetitor?.extendedResults?.find(er => er?.er_pos === '3') : ''

        trick2 = currentCompetitor?.extendedResults?.find(er => er?.er_pos === '4') ? currentCompetitor?.extendedResults?.find(er => er?.er_pos === '4') : ''

        trick3 = currentCompetitor?.extendedResults?.find(er => er?.er_pos === '5') ? currentCompetitor?.extendedResults?.find(er => er?.er_pos === '5') : ''

        trick4 = currentCompetitor?.extendedResults?.find(er => er?.er_pos === '6') ? currentCompetitor?.extendedResults?.find(er => er?.er_pos === '6') : ''

        trick5 = currentCompetitor?.extendedResults?.find(er => er?.er_pos === '7') ? currentCompetitor?.extendedResults?.find(er => er?.er_pos === '7') : ''
    }
    else if (park) {
        run3 = currentCompetitor?.extendedResults?.find(er => er?.er_pos === '3') ? currentCompetitor?.extendedResults?.find(er => er?.er_pos === '3') : ''
    }

    let currentRun = findArray(data?.results?.extendedInfos, { ei_code: ['CURRENT'] })

    let currentValue = currentRun?.ei_pos

    let rank1, rank2, rank3, rank8 = ''

    if (!final) {
        rank1 = findArray(currentRun?.extensions, { eie_pos: ['1'] }).eie_value
        rank2 = findArray(currentRun?.extensions, { eie_pos: ['2'] }).eie_value
        rank3 = findArray(currentRun?.extensions, { eie_pos: ['3'] }).eie_value
        rank8 = findArray(currentRun?.extensions, { eie_pos: ['8'] }).eie_value
    } else if (final) {
        rank1 = findArray(currentRun?.extensions, { eie_pos: ['1'] }).eie_value
        rank2 = findArray(currentRun?.extensions, { eie_pos: ['2'] }).eie_value
        rank3 = findArray(currentRun?.extensions, { eie_pos: ['3'] }).eie_value
    }

    return (
        <>
            {currentCompetitor && street
                ?
                <>
                    {breakPoint === "sm" || breakPoint === "xs"
                        ?
                        <></>
                        :
                        <div className="fw-bold"><Label data={'HeaderCurrentSkater'} sport={mirs_discipline} /></div>
                    }
                    <table class="table">
                        <thead>
                            <tr>
                                {breakPoint === "sm" || breakPoint === "xs"
                                    ?
                                    <>
                                        <th className="w-60" scope="col"><Label data={'HeaderCurrentSkater'} sport={mirs_discipline} /></th>
                                        <th scope="col"><Label data={'HeaderTotal'} /></th>
                                        <th scope="col"><Label data={'HeaderRk'} /></th>
                                    </>
                                    :
                                    <>
                                        <th className="text-center w-5" scope="col"><Label data={'LabelStartOrder'} /></th>
                                        <th className="text-start w-30" scope="col"><Label data={'HeaderName'} /></th>
                                        <th className="text-center w-10" scope="col"><Label data={'HeaderScoreNeeded'} sport={mirs_discipline} /></th>
                                        <th className="text-center w-15" colSpan="2" scope="col"><Label data={'HeaderRun'} /></th>
                                        <th className="text-center w-25" colSpan="5" scope="col"><Label data={'HeaderTRICK'} /></th>
                                        <th className="text-center w-5" scope="col"><Label data={'HeaderTotal'} /></th>
                                        <th className="text-center w-5" scope="col"><Label data={'HeaderRank'} /></th>
                                    </>
                                }
                            </tr>
                            <tr>
                                {breakPoint === "sm" || breakPoint === "xs"
                                    ?
                                    <></>
                                    :
                                    <>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th className="text-center w-5" ><Label data="Header1" sport={mirs_discipline} /></th>
                                        <th className="text-center w-5" ><Label data="Header2" sport={mirs_discipline} /></th>
                                        <th className="text-center w-5" ><Label data="Header1" sport={mirs_discipline} /></th>
                                        <th className="text-center w-5" ><Label data="Header2" sport={mirs_discipline} /></th>
                                        <th className="text-center w-5" ><Label data="Header3" sport={mirs_discipline} /></th>
                                        <th className="text-center w-5" ><Label data="Header4" sport={mirs_discipline} /></th>
                                        <th className="text-center w-5" ><Label data="Header5" sport={mirs_discipline} /></th>
                                        <th></th>
                                        <th></th>
                                    </>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {breakPoint === "sm" || breakPoint === "xs"
                                ?
                                <>
                                    <td rowSpan='4'><Competitor hidePicture={true} alwaysNoc={true} {...currentCompetitor?.participant} /></td>
                                    <td className="fw-bold">
                                        {currentCompetitor?.resultData
                                            ? currentCompetitor?.resultData
                                            : currentCompetitor?.resultIrm
                                        }
                                    </td>
                                    <td className="fw-bold">{currentCompetitor?.resultRank}</td>
                                </>
                                :
                                <>
                                    <td className="text-center" rowSpan='4'>{currentCompetitor?.startSortOrder}</td>
                                    <td className="text-start"><Competitor hidePicture={true} alwaysNoc={true} {...currentCompetitor?.participant} /></td>
                                    <td className="text-center">
                                        {final
                                            ?
                                            <>
                                                <Label data="HeaderRank1" sport={mirs_discipline} />:&ensp;{rank1}<br />
                                                <Label data="HeaderRank2" sport={mirs_discipline} />:&ensp;{rank2}<br />
                                                <Label data="HeaderRank3" sport={mirs_discipline} />:&ensp;{rank3}<br />
                                            </>
                                            :
                                            <>
                                                <Label data="HeaderRank1" sport={mirs_discipline} />:&ensp;{rank1}<br />
                                                <Label data="HeaderRank2" sport={mirs_discipline} />:&ensp;{rank2}<br />
                                                <Label data="HeaderRank3" sport={mirs_discipline} />:&ensp;{rank3}<br />
                                                <Label data="HeaderRank8" sport={mirs_discipline} />:&ensp;{rank8}<br />
                                            </>
                                        }
                                    </td>
                                    {run1 ? getResults(currentValue, currentCompetitor, run1?.er_pos) : <td></td>}
                                    {run2 ? getResults(currentValue, currentCompetitor, run2?.er_pos) : <td></td>}
                                    {trick1 ? getResults(currentValue, currentCompetitor, trick1?.er_pos) : <td></td>}
                                    {trick2 ? getResults(currentValue, currentCompetitor, trick2?.er_pos) : <td></td>}
                                    {trick3 ? getResults(currentValue, currentCompetitor, trick3?.er_pos) : <td></td>}
                                    {trick4 ? getResults(currentValue, currentCompetitor, trick4?.er_pos) : <td></td>}
                                    {trick5 ? getResults(currentValue, currentCompetitor, trick5?.er_pos) : <td></td>}
                                    <td className="text-center fw-bold">
                                        {currentCompetitor?.resultData
                                            ? currentCompetitor?.resultData
                                            : currentCompetitor?.resultIrm
                                        }
                                    </td>
                                    <td className="text-center fw-bold">{currentCompetitor?.resultRank}</td>
                                </>
                            }
                        </tbody>
                    </table>
                    {breakPoint === "sm" || breakPoint === "xs"
                        ?
                        <>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th className="text-center" colSpan="2" scope="col"><Label data={'HeaderRun'} /></th>
                                        <th className="text-center" colSpan="5" scope="col"><Label data={'HeaderTRICK'} /></th>
                                        <th className="text-center w-25" scope="col"><Label data={'HeaderScoreNeeded'} sport={mirs_discipline} /></th>
                                    </tr>
                                    <tr>
                                        <th className="text-center" ><Label data="Header1" sport={mirs_discipline} /></th>
                                        <th className="text-center" ><Label data="Header2" sport={mirs_discipline} /></th>
                                        <th className="text-center" ><Label data="Header1" sport={mirs_discipline} /></th>
                                        <th className="text-center" ><Label data="Header2" sport={mirs_discipline} /></th>
                                        <th className="text-center" ><Label data="Header3" sport={mirs_discipline} /></th>
                                        <th className="text-center" ><Label data="Header4" sport={mirs_discipline} /></th>
                                        <th className="text-center" ><Label data="Header5" sport={mirs_discipline} /></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {run1 ? getResults(currentValue, currentCompetitor, run1?.er_pos) : <td></td>}
                                    {run2 ? getResults(currentValue, currentCompetitor, run2?.er_pos) : <td></td>}
                                    {trick1 ? getResults(currentValue, currentCompetitor, trick1?.er_pos) : <td></td>}
                                    {trick2 ? getResults(currentValue, currentCompetitor, trick2?.er_pos) : <td></td>}
                                    {trick3 ? getResults(currentValue, currentCompetitor, trick3?.er_pos) : <td></td>}
                                    {trick4 ? getResults(currentValue, currentCompetitor, trick4?.er_pos) : <td></td>}
                                    {trick5 ? getResults(currentValue, currentCompetitor, trick5?.er_pos) : <td></td>}
                                    <td className="text-center">
                                        {final
                                            ?
                                            <>
                                                <Label data="HeaderRank1" sport={mirs_discipline} />:&ensp;{rank1}<br />
                                                <Label data="HeaderRank2" sport={mirs_discipline} />:&ensp;{rank2}<br />
                                                <Label data="HeaderRank3" sport={mirs_discipline} />:&ensp;{rank3}<br />
                                            </>
                                            :
                                            <>
                                                <Label data="HeaderRank1" sport={mirs_discipline} />:&ensp;{rank1}<br />
                                                <Label data="HeaderRank2" sport={mirs_discipline} />:&ensp;{rank2}<br />
                                                <Label data="HeaderRank3" sport={mirs_discipline} />:&ensp;{rank3}<br />
                                                <Label data="HeaderRank8" sport={mirs_discipline} />:&ensp;{rank8}<br />
                                            </>
                                        }
                                    </td>
                                </tbody>
                            </table>
                        </>
                        :
                        <></>
                    }
                </>
                : currentCompetitor && park
                    ?
                    <>
                        {breakPoint === "sm" || breakPoint === "xs"
                            ?
                            <></>
                            :
                            <div className="fw-bold"><Label data={'HeaderCurrentSkater'} sport={mirs_discipline} /></div>
                        }
                        <table class="table">
                            <thead>
                                <tr>
                                    {breakPoint === "sm" || breakPoint === "xs"
                                        ?
                                        <>
                                            <th className="w-60" scope="col"><Label data={'HeaderCurrentSkater'} sport={mirs_discipline} /></th>
                                            <th scope="col"><Label data={'HeaderBestScore'} /></th>
                                            <th scope="col"><Label data={'HeaderRk'} /></th>
                                        </>
                                        :
                                        <>
                                            <th className="text-center w-5" scope="col"><Label data={'LabelStartOrder'} /></th>
                                            <th className="text-start w-30" scope="col"><Label data={'HeaderName'} /></th>
                                            <th className="text-center w-20" scope="col"><Label data={'HeaderScoreNeeded'} sport={mirs_discipline} /></th>
                                            <th className="text-center w-30" colSpan="3" scope="col"><Label data={'HeaderRun'} /></th>
                                            <th className="text-center w-5" scope="col"><Label data={'HeaderBestScore'} /></th>
                                            <th className="text-center w-5" scope="col"><Label data={'HeaderRank'} /></th>
                                        </>
                                    }
                                </tr>
                                <tr>
                                    {breakPoint === "sm" || breakPoint === "xs"
                                        ?
                                        <></>
                                        :
                                        <>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th className="text-center w-10" ><Label data="Header1" sport={mirs_discipline} /></th>
                                            <th className="text-center w-10" ><Label data="Header2" sport={mirs_discipline} /></th>
                                            <th className="text-center w-10" ><Label data="Header3" sport={mirs_discipline} /></th>
                                            <th></th>
                                            <th></th>
                                        </>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {breakPoint === "sm" || breakPoint === "xs"
                                    ?
                                    <>
                                        <td rowSpan='4'><Competitor hidePicture={true} alwaysNoc={true} {...currentCompetitor?.participant} /></td>
                                        <td className="fw-bold">
                                            {currentCompetitor?.resultData
                                                ? currentCompetitor?.resultData
                                                : currentCompetitor?.resultIrm
                                            }
                                        </td>
                                        <td className="fw-bold">{currentCompetitor?.resultRank}</td>
                                    </>
                                    :
                                    <>
                                        <td className="text-center">{currentCompetitor?.startSortOrder}</td>
                                        <td className="text-start"><Competitor hidePicture={true} alwaysNoc={true} {...currentCompetitor?.participant} /></td>
                                        <td className="text-center">
                                            {final
                                                ?
                                                <>
                                                    <Label data="HeaderRank1" sport={mirs_discipline} />:&ensp;{rank1}<br />
                                                    <Label data="HeaderRank2" sport={mirs_discipline} />:&ensp;{rank2}<br />
                                                    <Label data="HeaderRank3" sport={mirs_discipline} />:&ensp;{rank3}<br />
                                                </>
                                                :
                                                <>
                                                    <Label data="HeaderRank1" sport={mirs_discipline} />:&ensp;{rank1}<br />
                                                    <Label data="HeaderRank2" sport={mirs_discipline} />:&ensp;{rank2}<br />
                                                    <Label data="HeaderRank3" sport={mirs_discipline} />:&ensp;{rank3}<br />
                                                    <Label data="HeaderRank8" sport={mirs_discipline} />:&ensp;{rank8}<br />
                                                </>
                                            }
                                        </td>
                                        {run1 ? getResults(currentValue, currentCompetitor, run1?.er_pos) : <td></td>}
                                        {run2 ? getResults(currentValue, currentCompetitor, run2?.er_pos) : <td></td>}
                                        {run3 ? getResults(currentValue, currentCompetitor, run3?.er_pos) : <td></td>}
                                        <td className="text-center fw-bold">
                                            {currentCompetitor?.resultData
                                                ? currentCompetitor?.resultData
                                                : currentCompetitor?.resultIrm
                                            }
                                        </td>
                                        <td className="text-center fw-bold">{currentCompetitor?.resultRank}</td>
                                    </>
                                }
                            </tbody>
                        </table>
                        {breakPoint === "sm" || breakPoint === "xs"
                            ?
                            <>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th className="text-center" scope="col"><Label data={'HeaderRun1'} sport={mirs_discipline} /></th>
                                            <th className="text-center" scope="col"><Label data={'HeaderRun2'} sport={mirs_discipline} /></th>
                                            <th className="text-center" scope="col"><Label data={'HeaderRun3'} sport={mirs_discipline} /></th>
                                            <th className="text-center" scope="col"><Label data={'HeaderScoreNeeded'} sport={mirs_discipline} /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {run1 ? getResults(currentValue, currentCompetitor, run1?.er_pos) : <td></td>}
                                        {run2 ? getResults(currentValue, currentCompetitor, run2?.er_pos) : <td></td>}
                                        {run3 ? getResults(currentValue, currentCompetitor, run3?.er_pos) : <td></td>}
                                        <td className="text-center">
                                            {final
                                                ?
                                                <>
                                                    <Label data="HeaderRank1" sport={mirs_discipline} />:&ensp;{rank1}<br />
                                                    <Label data="HeaderRank2" sport={mirs_discipline} />:&ensp;{rank2}<br />
                                                    <Label data="HeaderRank3" sport={mirs_discipline} />:&ensp;{rank3}<br />
                                                </>
                                                :
                                                <>
                                                    <Label data="HeaderRank1" sport={mirs_discipline} />:&ensp;{rank1}<br />
                                                    <Label data="HeaderRank2" sport={mirs_discipline} />:&ensp;{rank2}<br />
                                                    <Label data="HeaderRank3" sport={mirs_discipline} />:&ensp;{rank3}<br />
                                                    <Label data="HeaderRank8" sport={mirs_discipline} />:&ensp;{rank8}<br />
                                                </>
                                            }
                                        </td>
                                    </tbody>
                                </table>
                            </>
                            :
                            <></>
                        }
                    </>
                    :
                    <></>
            }
        </>
    )
}

const getResults = (currentValue, competitor, number) => {

    let result = competitor?.extendedResults?.find(er => er?.er_pos === number) ? competitor?.extendedResults?.find(er => er?.er_pos === number) : ''

    if (currentValue === number)
        return <td className="text-center competitor-current"></td>
    else if (result?.er_value2 === 'Y')
        return <td className="text-center fw-bold">{result?.er_value}</td>
    else if (result?.er_irm)
        return <td className="text-center">{result?.er_irm}</td>
    else if (result?.er_discard)
        return <td className="text-center">{result?.er_discard}</td>
    else
        return <td className="text-center">{result?.er_value}</td>
}

export default CurrentCompetitor;